<div class="container-xxl article-wrapper">
  <div class="article-inner">
    <div *ngIf="article.headerImage" class="article-stage">
      <mb-image class="absolute-positioned" mbParallax [media]="article.headerImage"></mb-image>
      <span *ngIf="article.fuelLabel" class="fuel-label copy-s" [innerHTML]="article.fuelLabel"></span>
    </div>
    <mb-info *ngIf="preMedia" type="danger">
      <div class="article-section-container">
        <div class="info-headline-wrapper">
          <span class="mb-icon mb-icon-attention-circle"></span>
          <h2 class="info-headline h4">{{ 'EMBARGO_CONFIRM_SUBLINE' | translate }}</h2>
        </div>
        <div class="info-subline copy-xl">{{ 'PRE_MEDIA_EMBARGO_HEADLINE' | translate }}</div>
        <p *ngFor="let embargoDate of preMedia.formatted_datetimes">
          {{ embargoDate }}
        </p>
        <div *ngIf="preMedia.enable_calendar" class="ics-btn-wrapper">
          <div class="btn btn-plain" (click)="openIcsModal()">
            <div class="mb-icon mb-icon-download"></div>
            <span>{{ 'DOWNLOAD_ICS' | translate }}</span>
          </div>
        </div>
      </div>
    </mb-info>
    <div class="article-content">
      <div [ngClass]="headlineContainerClasses" mbScrollSpy="ARTICLE">
        <div *ngIf="article.type === pressKitArticleType" class="article-section-container">
          <span class="btn btn-plain" routerLink="../..">{{ 'BACK_TO_OVERVIEW' | translate }}</span>
          <mb-accordion
            [isOpen]="showPressKitArticles"
            [hideIcon]="true"
            (toggled)="togglePressKitArticlesAccordion($event)"
            *ngIf="pressKitArticles && pressKitArticles.length > 1"
          >
            <div accordion-header class="accordion-header">
              <h4>{{ 'ARTICLE_OVERVIEW' | translate }}</h4>
              <div class="accordion-icon-container">
                <span class="mb-badge-small">{{ pressKitArticles.length }}</span>
                <span class="accordion-icon mb-icon mb-icon-down-thin"></span>
              </div>
            </div>
            <div accordion-content class="copy-l">
              <nav>
                <a
                  *ngFor="let pressKitArticle of pressKitArticles; let i = index"
                  class="btn btn-plain"
                  [class.active-link]="pressKitArticle.id === activePressKitArticleId"
                  routerLink="{{ '../' + pressKitArticle.id }}"
                >
                  {{ pressKitArticle.title }}
                </a>
              </nav>
            </div>
          </mb-accordion>
        </div>

        <h1 [ngClass]="headlineClass">{{ article.title }}</h1>
        <div *ngIf="article.type !== pressKitArticleType" class="article-info-container">
          <div class="article-info-top">
            <span class="article-info-location">{{ article.location }}</span>
            <span class="article-info-date" *ngIf="!preMedia"
              >, {{ article.displayDate | localizedDate: 'longDate' }}</span
            >
          </div>
          <div class="article-info-separator"></div>
          <div class="article-info-bottom">
            <mb-meta-items
              [metaItems]="article.metaItems"
              itemClass="btn btn-plain"
              (itemClicked)="scrollToAnchor($event)"
            ></mb-meta-items>

            <mb-action-container
              [buttonItems]="article.type === pressKitArticleType ? pressKitArticleDefaultActions : defaultActions"
              [resource]="article"
              (actionClick)="actionClick.emit({ action: $event, resource: article })"
            >
            </mb-action-container>
          </div>
        </div>

        <div *ngIf="article.fuelLabel" class="fuel-labels">
          <span class="copy-s" [innerHTML]="article.fuelLabel"></span>
        </div>
      </div>

      <div class="article-section-container article-section">
        <mb-expandable-copy [text]="article.content"></mb-expandable-copy>
      </div>

      <div
        *ngIf="article.imageCount && article.images.length"
        class="article-section"
        id="article_image_section"
        mbScrollSpy="IMAGES"
      >
        <div class="article-section-container">
          <div class="article-section-headline-wrapper">
            <h2 class="article-section-headline">
              {{ 'IMAGES' | translate }}
              <div class="mb-badge-small">{{ article.imageCount }}</div>
            </h2>

            <mb-action-container
              [buttonItems]="sectionActions"
              [resource]="article.images"
              (actionClick)="actionClick.emit({ action: $event, resource: article.images })"
            >
            </mb-action-container>
          </div>
        </div>
        <mb-article-gallery
          [items]="article.images"
          [buttonItems]="defaultActions"
          (itemClicked)="openMediaGallery(article.images, $event.index)"
          (itemActionClicked)="actionClick.emit({ action: $event.action, resource: $event.media })"
        >
        </mb-article-gallery>
      </div>

      <div *ngIf="article.videoCount" id="article_video_section" mbScrollSpy="VIDEOS">
        <div class="article-section-container">
          <div class="article-section-headline-wrapper">
            <h2 class="article-section-headline">
              {{ 'VIDEOS' | translate }}
              <div class="mb-badge-small">{{ article.videoCount }}</div>
            </h2>

            <mb-action-container
              [buttonItems]="sectionActions"
              [resource]="article.videos"
              (actionClick)="actionClick.emit({ action: $event, resource: article.videos })"
            >
            </mb-action-container>
          </div>
        </div>
        <div class="article-section">
          <mb-masonry-gallery
            [items]="article.videos"
            [buttonItems]="defaultActions"
            (itemClicked)="openMediaGallery(article.videos, $event.index)"
            (itemActionClicked)="actionClick.emit({ action: $event.action, resource: $event.media })"
          >
          </mb-masonry-gallery>
        </div>
      </div>

      <div
        *ngIf="article.documentCount"
        class="article-section-container article-section"
        id="article_document_section"
        mbScrollSpy="DOCUMENTS"
      >
        <div class="article-section-headline-wrapper">
          <h2 class="article-section-headline">
            {{ 'DOCUMENTS' | translate }}
            <div class="mb-badge-small">{{ article.documentCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="article.documents"
            (actionClick)="actionClick.emit({ action: $event, resource: article.documents })"
          >
          </mb-action-container>
        </div>
        <div class="document-item-list">
          <mb-document-card
            *ngFor="let document of article.documents; let index = index"
            [document]="document"
            [actions]="defaultActions"
            (click)="openMediaGallery(article.documents, index)"
            (actionClick)="actionClick.emit($event)"
          ></mb-document-card>
        </div>
      </div>

      <div
        *ngIf="article.technicalDataCount"
        class="article-section-container article-section"
        id="article_technical_data_section"
        mbScrollSpy="TECHNICAL_DATAS"
      >
        <div class="article-section-headline-wrapper">
          <h2 class="article-section-headline">
            {{ 'TECHNICAL_DATAS' | translate }}
            <div class="mb-badge-small">{{ article.technicalDataCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="article.technicalDatas"
            (actionClick)="actionClick.emit({ action: $event, resource: article.technicalDatas })"
          >
          </mb-action-container>
        </div>
        <div class="document-item-list" *ngIf="article.technicalDataCount">
          <mb-document-card
            *ngFor="let document of article.technicalDatas; let index = index"
            [document]="document"
            [actions]="defaultActions"
            (click)="openMediaGallery(article.technicalDatas, index)"
            (actionClick)="actionClick.emit($event)"
          ></mb-document-card>
        </div>
      </div>

      <div
        *ngIf="article.audioCount"
        class="article-section-container article-section"
        id="article_audio_section"
        mbScrollSpy="AUDIOS"
      >
        <div class="article-section-headline-wrapper">
          <h2 class="article-section-headline">
            {{ 'AUDIOS' | translate }}
            <div class="mb-badge-small">{{ article.audioCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="article.audios"
            (actionClick)="actionClick.emit({ action: $event, resource: article.audios })"
          >
          </mb-action-container>
        </div>
        <div class="audio-list">
          <mb-audio
            [actions]="defaultActions"
            *ngFor="let audio of article.audios; let index = index"
            [media]="audio"
            #audioPlayer
            (click)="audioPlayer.pause(); openMediaGallery(article.audios, index)"
            (actionClick)="actionClick.emit({ action: $event, resource: audio })"
          ></mb-audio>
        </div>
      </div>

      <div
        *ngIf="article.contacts.length"
        class="article-section-container article-section"
        mbScrollSpy="PRESS_CONTACTS"
      >
        <div class="article-section-headline-wrapper">
          <h2 class="article-section-headline">
            {{ 'PRESS_CONTACTS' | translate }}
            <div class="mb-badge-small">{{ article.contacts.length }}</div>
          </h2>
        </div>
        <div class="press-contact-item-list">
          <mb-contact-person-card
            class="light-card column-card"
            *ngFor="let person of article.contacts"
            [hideMedia]="true"
            [fullname]="person.fullname"
            [position]="person.position"
            [email]="person.email"
            [phone]="person.phone"
          ></mb-contact-person-card>
        </div>
      </div>

      <div [ngClass]="buttonHubClass" class="article-section-container article-section">
        <mb-action-container
          class="large"
          [buttonItems]="articleActions"
          [resource]="article"
          (actionClick)="actionClick.emit({ action: $event, resource: article })"
        >
        </mb-action-container>
      </div>

      <div *ngIf="article.type === pressKitArticleType" class="article-section-container article-section">
        <div class="article-info-separator"></div>
        <div class="article-bottom-btn-section">
          <span routerLink="../.." class="btn btn-plain">
            {{ 'BACK_TO_OVERVIEW' | translate }}
          </span>
          <span *ngIf="nextPressKitArticleId" (click)="goToNextArticle()" class="btn btn-plain">
            {{ 'NEXT_ARTICLE' | translate }}
          </span>
        </div>
      </div>
    </div>
    <mb-article-status-bar
      [article]="article"
      [title]="article.title"
      [metaItems]="article.metaItems"
      [buttonItems]="article.type === pressKitArticleType ? pressKitArticleDefaultActions : defaultActions"
      (metaItemClicked)="scrollToAnchor($event)"
    ></mb-article-status-bar>
  </div>
</div>
